import { Check, Circle } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { formatDate } from '@/lib/customer-format'
import type { CustomerOnboarding } from '@/lib/customer-types'

export function CustomerOnboardingSection({
  onboarding,
}: {
  onboarding: CustomerOnboarding
}) {
  const { completedCount, total, milestones, onboardedAt } = onboarding
  const pct = total > 0 ? Math.round((completedCount / total) * 100) : 0

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Onboarding · {completedCount}/{total}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {/* Progress bar */}
        <div className="mb-4">
          <div className="mb-1 flex items-center justify-between">
            <span className="font-mono text-xs tabular-nums text-white/80">{pct}%</span>
            {onboardedAt && (
              <span className="font-label text-[0.6rem] uppercase tracking-wider text-cmd-outline">
                Completed {formatDate(onboardedAt)}
              </span>
            )}
          </div>
          <div className="h-2 w-full overflow-hidden rounded-sm bg-cmd-low">
            <div className="h-full bg-primary" style={{ width: `${pct}%` }} />
          </div>
        </div>

        {/* Milestones */}
        <ul className="space-y-2">
          {milestones.map((m) => (
            <li key={m.key} className="flex items-center gap-2.5 text-sm">
              {m.complete ? (
                <Check className="h-4 w-4 shrink-0 text-[#80ffb4]" aria-hidden="true" />
              ) : (
                <Circle className="h-4 w-4 shrink-0 text-cmd-outline-variant" aria-hidden="true" />
              )}
              <span className={m.complete ? 'text-white/90' : 'text-cmd-outline'}>{m.label}</span>
            </li>
          ))}
        </ul>

        <p className="mt-4 font-label text-[0.6rem] uppercase tracking-wider text-cmd-outline">
          Derived from product activation signals
        </p>
      </CardContent>
    </Card>
  )
}
